import { ENCRYPTION_KEY , API_KEY} from "constants/environment";
import CryptoJS from "crypto-js";
import { consoleLog } from "helpers";


// Encrypt function
export function encryptData(data) {
  consoleLog([data, "payload"]);
  const stringifiedData = JSON.stringify(data); // Convert data to string
  return CryptoJS.AES.encrypt(stringifiedData, ENCRYPTION_KEY).toString();
}

// Decrypt function
export function decryptData(encryptedData) {
  consoleLog([encryptedData,'encryptedData'])
  const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8); // Get the decrypted string
  // consoleLog([JSON.parse(JSON.parse(decryptedData)), "response"]);
  consoleLog([decryptedData,'decryptedData'])
  return JSON.parse(decryptedData); // Parse string back to object
}

export function getHeaderConfig(signal, accessJWT) {
  if (signal)
    return {
      headers: {
        "Content-Type": "text/plain",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": accessJWT,
        "x-api-key": API_KEY,
      },
      signal,
    };
  return {
    headers: {
      "Content-Type": "text/plain",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "x-access-token": accessJWT,
       "x-api-key": API_KEY,
    },
  };
}
